import { Wrapper } from 'AppReact';
import styled, { css } from 'styled-components';

const template = styled.div`
  ${({ displayState }) => css`
    svg {
      fill: ${displayState?.selected ? window?.settings?.primary_color ?? '#1DBD6B' : '#9EACB0'};
      margin-right: 3px;
    }

    &:hover {
      background: ${displayState?.allowEdit ? '#E8F8F0' : ''};
      color: ${displayState?.allowEdit ? window?.settings?.primary_color ?? '#1DBD6B' : ''};
      svg {
        fill: ${displayState?.allowEdit ? window?.settings?.primary_color ?? '#1DBD6B' : ''};
      }
    }
  `}
`;

export default Wrapper(template);